import { apiPost } from './http';

// ---------------- API CALLS ----------------
export async function loginApi({ username, password }) {
  // call admin login endpoint
  const data = await apiPost('/auth/admin/login/', { username, password });

  const token =
    data?.token || data?.access || data?.access_token || data?.jwt || data?.data?.token;
  return { data, token };
}

// ---------------- TOKEN HELPERS ----------------
function getKeys(admin) {
  const USER_KEY = import.meta.env.VITE_TOKEN_STORAGE_KEY || 'auth_token';
  const ADMIN_KEY = import.meta.env.VITE_ADMIN_TOKEN_STORAGE_KEY || 'admin_auth_token';
  return admin ? ADMIN_KEY : USER_KEY;
}

export function storeToken(token, remember, { admin = false } = {}) {
  const KEY = getKeys(admin);
  const store = remember ? localStorage : sessionStorage;
  store.setItem(KEY, token);
}

export function getToken({ admin = false } = {}) {
  const KEY = getKeys(admin);
  return localStorage.getItem(KEY) || sessionStorage.getItem(KEY);
}

export function clearToken({ admin = false } = {}) {
  const KEY = getKeys(admin);
  localStorage.removeItem(KEY);
  sessionStorage.removeItem(KEY);
}
